module.exports = __webpack_public_path__ + "img/linkedin-love.90cf9131.png";